import './Logo.css'
import React from 'react';
import myLogo from '../../../assets/logo/logo.png'

const logo=(props)=>{
    return(
        <div className='row inChatTopRowLeft'>
            <div className='loginSection'>
                <img className='myLogo' alt='ContactCenter' src={myLogo}></img>
                {/* <div className='logo'><label className='logoTitle'>ContactCenter</label></div> */}
                <i className="fas fa-home fa-lg myIcon" onClick={()=>props.changeWindowToShow(1)}></i>
            </div>
        </div>
    )
}
export default logo